import React from 'react'
import { Card} from 'semantic-ui-react'

import DetalheEvento from './DetalheEvento'
import { Titulo1 } from '../Layout/Titulo'
class ListaEventos extends React.Component {

    constructor(props) {
        super(props)

        
        this.state = {
            eventos: props.source,
            activeIndex: [],//[] traz todos as atividades 'fechadas'; [0]traz todas as atividades abertas
        }
    }
    render() {

        return <div>

            <Titulo1 content={this.props.titulo} />

            {this.props.subTitulo && <h3>{this.props.subTitulo}</h3>}
            {this.props.htmlSubtitle && <div dangerouslySetInnerHTML={this.props.htmlSubtitle}></div>}

            <Card.Group >
                {this.props.source.map((e, i) => (
                    <DetalheEvento
                        key={i}
                        index={i}
                        activeIndex={this.state.activeIndex}
                        evento={e}
                        icExibeNPS={this.props.icExibeNPS}
                        loginOptions={this.props.options}
                        eventHandlers={this.props.eventHandlers}
                        handleAccordion={(e, t) => this.handleAccordion(e, t)}
                    />
                ))}
            </Card.Group>


        </div >
    }

    handleAccordion(e, titleProps) {
        
        const { index } = titleProps
        const { activeIndex } = this.state
        let newState

        if (activeIndex.indexOf(index) > -1) {
            newState = activeIndex.filter((i) => i !== index);
          } else {
            newState = [...activeIndex, index]
          }
        this.setState({ activeIndex: newState })
    }
}

export default ListaEventos


// WEBPACK FOOTER //
// ./src/components/Eventos/ListaEventos.js